export const NoticeStatusLabel = {
    DRAFT: '작성중',
    PENDING_APPROVAL: '승인대기',
    APPROVED: '승인됨',
    SENT: '발송됨',
}

export const AvailabilityLabel = {
    ON_DUTY: '근무중',
    VACATION: '휴가',
    TRAINING: '교육',
    AWAY: '부재중',
}

export const AccountStatusLabel = {
    ACTIVE: '활성',
    INACTIVE: '비활성',
    SUSPENDED: '정지',
    PENDING: '승인 대기',
}

export const RoleLabel = {
    OPERATOR: '운영자',
    GA_LEADER: 'GA 대표',
    GA_MANAGER: 'GA 관리자',
    GA_OPERATION_MANAGER: 'GA 매니저',
    GA_PLANNER: '설계사',
    INSURER_LEADER: '원수사 대표',
    INSURER_MANAGER: '원수사 관리자',
    INSURER_OPERATION_MANAGER: '원수사 매니저',
    INSURER_PLANNER: '원수사 설계사',
}

export const RequestStatusLabel = {
    RECEIVED: '접수',
    ASSIGNED: '배정완료',
    IN_PROGRESS: '진행중',
    RE_REQUESTED: '보완/확인요청',
    QUESTION: '문의',
    COMPLETED: '완료',
    CANCELED: '취소',
}

export const NoticeLogStatusLabel = {
    SENT: '발송됨',
    FAILED: '실패',
    PENDING: '대기',
}


